import React, { useState, useRef, useEffect } from "react";

const DisplayNameDropdown = ({ options, selected, onSelectedChange }) => {
  const ref = useRef();
  useEffect(() => {
    const bodyClick = (e) => {
      if (ref.current.contains(e.target)) {
        return;
      }
      setOpen(false);
    };
    document.body.addEventListener("click", bodyClick);

    // clean up eventListener
    return () => {
      document.body.removeEventListener("click", bodyClick);
    };
  }, []);

  const [open, setOpen] = useState(false);
  const rendredOptions = options.map((option) => {
    if (option.display_name === selected.display_name) {
      return null;
    }
    return (

        <option value={option.id} key={option.id}>{option.display_name}</option>


    );
  });
  return (
<div>
<form className="max-w-sm mx-auto">
  <select id="names" className="bg-yellow border-gray-300 text-gray-900 text-sm hover:border-blue-500 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
  onClick={() => setOpen(!open)}
  onChange={(event) => onSelectedChange(event.target.value)}
  ref={ref}
  >
    {selected && (
    <option>{selected}</option>
    )}
  {rendredOptions}
  </select>
</form>
</div>
  );
};

export default DisplayNameDropdown;
